const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/labReports/load1LabSingleReportHandlers.ts';
import Imm from 'immutable';
import { incCounter, decCounter } from '../../utils/reducerUtils';
import { IKisApiHandlersMap } from '../../defs/actionTypes';
import { Load1LabSingleReportAction } from '../../actions/labReportsActions';
import { Logger } from '../../services/KisLoggerService';
import { putLabSingleRepIntoState } from '../../utils/labReportUtils';

const Log = Logger('labReports/load1SingleRep');

export const load1LabSingleReportHandlers: IKisApiHandlersMap<Load1LabSingleReportAction> = {
    pending: (state, action) => {
        const repId = `${action.meta.sender}_${action.meta.reportnr}`;
        return incCounter(state, ['loading', 'singleReports', repId]);
    },
    success: (state, action) => {
        const repId = `${action.meta.sender}_${action.meta.reportnr}`;
        let rec = Imm.fromJS(action.payload);
        const patnr = rec.get('PATNR');

        if (!patnr) {
            Log.error(`Report with missing PATNR: ${repId}`);
        } else {
            if (action.meta.etag) {
                rec = rec.set('ETAG', action.meta.etag);
            }

            state = putLabSingleRepIntoState(state, rec, patnr);
        }

        return decCounter(state, ['loading', 'singleReports', repId]);
    },
    failure: (state, action) => {
        Log.warn('Failed to load the lab single report!', action);
        const repId = `${action.meta.sender}_${action.meta.reportnr}`;
        return decCounter(state, ['loading', 'singleReports', repId]);
    },
};
